import * as z from "zod";

export const getRichpanelConnectionStatus = {
  name: "getRichpanelConnectionStatus" as const,
  input: z.null(),
  output: z.object({
    connected: z.boolean(),
    account: z.nullable(z.string()),
    smsPhoneNumber: z.nullable(z.string()),
  }),
};
